export default __webpack_public_path__ + "static/media/about-us-industrial.269fea11.jpg";